/**
 * Stable CSS class names for E2E — Estimated shipping date (summary + 14-day forecast grid).
 */
export const ESD = {
    page: 'estimated-shipping-date-page',
    loadingWrap: 'estimated-shipping-date-page__loading-wrap',
    mainGrid: 'estimated-shipping-date-page__main-grid',
    summaryWrap: 'estimated-shipping-date-page__summary-wrap',
    forecastGridWrap: 'estimated-shipping-date-page__forecast-grid-wrap',
} as const;

export const ESDSUM = {
    paper: 'estimated-shipping-date-summary',
    table: 'estimated-shipping-date-summary__table',
    summaryRow: 'estimated-shipping-date-summary__row',
    cellTodayLabel: 'estimated-shipping-date-summary-cell--today-label',
    cellBacklogHeader: 'estimated-shipping-date-summary-cell--backlog-header',
    cellBacklogValue: 'estimated-shipping-date-summary-cell--backlog-value',
    cellShippedFromBoHeader: 'estimated-shipping-date-summary-cell--shipped-from-backoffice-header',
    inputTextfieldShippedFromBo: 'estimated-shipping-date-summary-input--textfield-shipped-from-backoffice',
    cellEstimatedShippedHeader: 'estimated-shipping-date-summary-cell--estimated-shipped-header',
    cellEstimatedShippedValue: 'estimated-shipping-date-summary-cell--estimated-shipped-value',
    actionsRow: 'estimated-shipping-date-summary__actions-row',
    inputButtonSaveEstimations: 'estimated-shipping-date-summary-input--button-save-estimations',
    inputButtonSaveBacklog: 'estimated-shipping-date-summary-input--button-save-backlog',
} as const;

export const ESDGRID = {
    paper: 'estimated-shipping-date-forecast-grid',
    table: 'estimated-shipping-date-forecast-grid__table',
    headerRow: 'estimated-shipping-date-forecast-grid__header-row',
    bodyRow: 'estimated-shipping-date-forecast-grid__body-row',
    inputTextfieldSalesForecast: 'estimated-shipping-date-forecast-grid-input--textfield-sales-forecast',
    inputTextfieldWarehouseExit: 'estimated-shipping-date-forecast-grid-input--textfield-warehouse-exit',
} as const;

export const esdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
